<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cogs', fontSet: 'fad'}"
	[headerText]="data.viewingStationMapping.name + (T.VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="col-lg-12 col-md-12 col-sm-12">
			<mat-form-field color="accent">
				<mat-label for="txtUsername">{{ T.MAPPING_CONFIGURATION_DIALOG_USERNAME | translate }}</mat-label>
				<input
					[(ngModel)]="data.viewingStationMapping.deviceUsername"
					[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_USERNAME | translate"
					class="form-control"
					id="txtUsername"
					matInput
					type="text"
				/>
				<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_USERNAME_DESCRIPTION | translate }}</mat-hint>
			</mat-form-field>
			<mat-form-field color="accent">
				<mat-label for="txtPassword">{{ T.MAPPING_CONFIGURATION_DIALOG_PASSWORD | translate }}</mat-label>
				<input
					[(ngModel)]="data.viewingStationMapping.devicePassword"
					[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_PASSWORD | translate"
					[type]="hidePassword ? 'password' : 'text'"
					class="form-control"
					id="txtPassword"
					matInput
				/>
				<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_PASSWORD_DESCRIPTION | translate }}</mat-hint>

				<button
					(click)="hidePassword = !hidePassword"
					[attr.aria-label]="'Hide password'"
					[attr.aria-pressed]="hidePassword"
					mat-icon-button
					matSuffix
				>
					@if (hidePassword) {
						<mat-icon fontSet="fas" fontIcon="fa-eye-slash" style="font-size: 0.8em" inline />
					}
					@if (!hidePassword) {
						<mat-icon fontSet="far" fontIcon="fa-eye" style="font-size: 0.8em" inline />
					}
				</button>
			</mat-form-field>

			<mat-form-field color="accent">
				<mat-label for="txtIpAddress">{{ T.MAPPING_CONFIGURATION_DIALOG_IP_ADDRESS | translate }}</mat-label>
				<input
					[(ngModel)]="data.viewingStationMapping.ip"
					[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '192.168.89.30'}"
					class="form-control"
					id="txtIpAddress"
					matInput
					type="text"
				/>
			</mat-form-field>

			<mat-form-field color="accent">
				<mat-label for="txtSubnetMask">{{ T.MAPPING_CONFIGURATION_DIALOG_SUBNET_MASK | translate }}</mat-label>
				<input
					[(ngModel)]="data.viewingStationMapping.subnetMask"
					[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '255.255.255.0'}"
					class="form-control"
					id="txtSubnetMask"
					matInput
					type="text"
				/>
			</mat-form-field>

			<mat-form-field color="accent">
				<mat-label class="label" for="txtMacAddress">{{ T.MAPPING_CONFIGURATION_DIALOG_MAC_ADDRESS | translate }}</mat-label>
				<div style="display: flex; flex-direction: row">
					<span class="input-group-btn">
						<a (click)="findMacAddressForViewingStation(data.viewingStationMapping.ip)" class="btn btn-default">
							<mat-icon size="10px">search</mat-icon>
						</a>
					</span>
					<input
						[(ngModel)]="data.viewingStationMapping.macAddress"
						[placeholder]="T.MAPPING_CONFIGURATION_DIALOG_EXAMPLE_PLACEHOLDER | translate: {text: '4C:ED:FB:91:62:F3'}"
						class="form-control"
						id="txtMacAddress"
						matInput
						type="text"
					/>
				</div>
				<mat-hint>{{ T.MAPPING_CONFIGURATION_DIALOG_MAC_ADDRESS_DESCRIPTION | translate }}</mat-hint>
			</mat-form-field>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="saveViewingStationMapping()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
